/* eslint-disable @typescript-eslint/naming-convention */
import { publicConfig } from 'config'
import { aboutNewPageMapper } from 'data-source/mappers/aboutNewPageMapper'
import { bestMapper } from 'data-source/mappers/bestMapper'
import { categoryPageMapper } from 'data-source/mappers/categoryMapper'
import { cbColoredTiles } from 'data-source/mappers/cbColoredTiles'
import { cbComponent } from 'data-source/mappers/cbComponent'
import { cbCoupledPosts } from 'data-source/mappers/cbCoupledPosts'
import { cbFeatured } from 'data-source/mappers/cbFeatured'
import { cbMissed } from 'data-source/mappers/cbMissed'
import { cbTiles } from 'data-source/mappers/cbTiles'
import { codecDiscoveryNewPage } from 'data-source/mappers/codecDiscoveryNewPage'
import { codecGetCategoryNewPage } from 'data-source/mappers/codecGetCategoryNewPage'
import { codecGetDealsCategoryPage } from 'data-source/mappers/codecGetDealsCategoryPage'
import { codecGetMissedProps } from 'data-source/mappers/codecGetMissedProps'
import { codecGetTopicPage } from 'data-source/mappers/codecGetTopicPage'
import { contactsPageMapper } from 'data-source/mappers/contactsPageMapper'
import { creditMapper } from 'data-source/mappers/creditMapper'
import { eventPageMapper } from 'data-source/mappers/eventPageMapper'
import { imageListMapper } from 'data-source/mappers/imageListMapper'
import { imageMapper } from 'data-source/mappers/imageMapper'
import { ncAd } from 'data-source/mappers/ncAd'
import { ncAdpFaqs } from 'data-source/mappers/ncAdpFaqs'
import { ncAlert } from 'data-source/mappers/ncAlert'
import { ncApp } from 'data-source/mappers/ncApp'
import { ncAudio } from 'data-source/mappers/ncAudio'
import { ncAudioChart } from 'data-source/mappers/ncAudioChart'
import { ncBestProductGallery } from 'data-source/mappers/ncBestProductGallery'
import { ncBestProductTitle } from 'data-source/mappers/ncBestProductTitle'
import { ncCarousel } from 'data-source/mappers/ncCarousel'
import { ncColumns } from 'data-source/mappers/ncColumns'
import { ncDealsLarge } from 'data-source/mappers/ncDealsLarge'
import { ncDealsList } from 'data-source/mappers/ncDealsList'
import { ncDealsSlider } from 'data-source/mappers/ncDealsSlider'
import { ncDisclosureBox } from 'data-source/mappers/ncDisclosureBox'
import { ncEmbed } from 'data-source/mappers/ncEmbed'
import { ncError } from 'data-source/mappers/ncError'
import { ncFaq } from 'data-source/mappers/ncFaq'
import { ncFaqSubmission } from 'data-source/mappers/ncFaqSubmission'
import { ncFeedback } from 'data-source/mappers/ncFeedback'
import { ncGallery } from 'data-source/mappers/ncGallery'
import { ncImage } from 'data-source/mappers/ncImage'
import { ncImageWithBadge } from 'data-source/mappers/ncImageWithBadge'
import { ncImgComparison } from 'data-source/mappers/ncImgComparison'
import { ncLinkedButtons } from 'data-source/mappers/ncLinkedButtons'
import { ncMorePosts } from 'data-source/mappers/ncMorePosts'
import { ncMulti } from 'data-source/mappers/ncMulti'
import { ncNewsletter } from 'data-source/mappers/ncNewsletter'
import { ncOpinions } from 'data-source/mappers/ncOpinions'
import { ncPoll } from 'data-source/mappers/ncPoll'
import { ncPostsList } from 'data-source/mappers/ncPostsList'
import { ncPre } from 'data-source/mappers/ncPre'
import { ncProduct } from 'data-source/mappers/ncProduct'
import { ncProductsQuiz } from 'data-source/mappers/ncProductsQuiz'
import { ncPromoted } from 'data-source/mappers/ncPromoted'
import { ncQuote } from 'data-source/mappers/ncQuote'
import { ncRelatedArticles } from 'data-source/mappers/ncRelatedArticles'
import { ncScript } from 'data-source/mappers/ncScript'
import { ncSection } from 'data-source/mappers/ncSection'
import { ncSeeAlso } from 'data-source/mappers/ncSeeAlso'
import { ncSpecTable } from 'data-source/mappers/ncSpecTable'
import { ncSponsored } from 'data-source/mappers/ncSponsored'
import { ncString } from 'data-source/mappers/ncString'
import { ncTable } from 'data-source/mappers/ncTable'
import { ncTldr } from 'data-source/mappers/ncTldr'
import { ncTrustUs } from 'data-source/mappers/ncTrustUs'
import { ncTwitter } from 'data-source/mappers/ncTwitter'
import { ncUnsafeHtml } from 'data-source/mappers/ncUnsafeHtml'
import { ncVideo } from 'data-source/mappers/ncVideo'
import { ncVideoSlider } from 'data-source/mappers/ncVideoSlider'
import { newsTitleMapper } from 'data-source/mappers/newsTitleMapper'
import { postPageMapper } from 'data-source/mappers/postPageMapper'
import { productBarsMapper } from 'data-source/mappers/productBarsMapper'
import { productPromotedMapper } from 'data-source/mappers/productPromotedMapper'
import { redirectMapper } from 'data-source/mappers/redirectMapper'
import { reviewProductPartMapper } from 'data-source/mappers/reviewProductPartMapper'
import { sidedCategoryPageMapper } from 'data-source/mappers/sidedCategoryPageMapper'
import { textPageMapper } from 'data-source/mappers/textPageMapper'
import * as buildersOpts from 'ds/mappers/link-wrappers'
import { linkBuilder as lb } from 'links'
import { logWarning } from 'shared-code/log'
import { DSRedirect, MapComponentItem } from 'shared-definitions/types'
import { DSContentBlockSG, DSNCSG, DSTplPage } from 'types.sg.ds'
import {
  ApiComponentPropsSG,
  ApiComponentPropsStrictSG,
  ApiContentBlockSG,
  ApiResponseTplPage,
} from 'types.sg.wp'
import { ncSeparator } from 'data-source/mappers/ncSeparator'
import { ncReviewFromWebMapper } from 'data-source/mappers/ncReviewFromWebMapper'
import { ncEngagementStarter } from 'data-source/mappers/ncEngagementStarter'

// **********************

export function codecGetTplPage(
  raw: ApiResponseTplPage,
  slug: string
): DSTplPage | DSRedirect | null {
  if ('redirect' in raw) {
    return redirectMapper(raw)
  }
  if (!('data' in raw) || !('template' in raw.data)) {
    return null
  }

  const input = raw.data
  if (input.template === 'events') {
    return eventPageMapper(input, {
      firstDesktopAd: 'video',
      ampPagePath: null,
      ad: publicConfig('inlineAdClass'),
      video: publicConfig('inlineAdVideoClass'),
      maxAdInserts: publicConfig('adsMaxInserts'),
      insertAdEveryDesktop: publicConfig('adsFrequencyDesktop'),
      insertAdEveryMobile: publicConfig('adsFrequencyMobile'),
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
      componentItemMapper,
      ...buildersOpts,
    })
  }
  if (input.template === 'topic' || input.template === 'topic-nested') {
    return codecGetTopicPage(input, buildersOpts)
  }
  if (input.template === 'discovery-layout') {
    return codecDiscoveryNewPage(input, {
      ...buildersOpts,
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
    })
  }
  if (input.template === 'category-new') {
    return codecGetCategoryNewPage(input, {
      componentItemMapper,
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
      slug,
      ...buildersOpts,
    })
  }
  if (input.template === 'text-layout') {
    const result = textPageMapper(input, {
      ampPagePath: null,
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
      componentItemMapper,
      ...buildersOpts,
    })
    return {
      ...result,
      blocks: [
        { resource: 'nc-string', html: `<h1>${input.content.title}</h1>` },
        ...result.blocks,
      ],
    }
  }
  if (input.template === 'category') {
    return categoryPageMapper(input, {
      slug,
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
      ...buildersOpts,
    })
  }
  if (input.template === 'deals-category') {
    return codecGetDealsCategoryPage(input, {
      componentItemMapper,
      slug,
      pagePath: lb.buildSiteLink({ path: 'deals' }).href,
      ...buildersOpts,
    })
  }
  if (input.template === 'category-2') {
    return sidedCategoryPageMapper(input, {
      slug,
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
      ...buildersOpts,
    })
  }
  if (input.template === 'best_list') {
    const result = postPageMapper(input, {
      firstDesktopAd: 'video',
      ampPagePath: null,
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
      ad: publicConfig('inlineAdClass'),
      video: publicConfig('inlineAdVideoClass'),
      componentItemMapper,
      ...buildersOpts,
    })

    // disabled because of https://drewlagency.slack.com/archives/C06EHUX8D46/p1739500956837539
    // injectTrendingArticlesList(
    //   result.meta.engagementContainerId,
    //   ['sg_131955'], // fix for https://drewl.atlassian.net/browse/DT-7128
    //   result.sidebarContent
    // )

    return {
      ...result,
      ...productBarsMapper(result.blocks),
      resource: 'best-list-page',
      sources: input.content.sources
        ? input.content.sources.map(i => creditMapper(i, buildersOpts))
        : [],
      bestList: input.best_list?.flatMap(i => bestMapper(i, buildersOpts)) ?? [],
      promotedProduct: input.promoted_product
        ? productPromotedMapper(input.promoted_product, buildersOpts)
        : null,
    }
  }
  if (input.template === 'post') {
    const result = {
      ...postPageMapper(input, {
        firstDesktopAd: 'video',
        ampPagePath: null,
        pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
        ad: publicConfig('inlineAdClass'),
        video: publicConfig('inlineAdVideoClass'),
        componentItemMapper,
        ...buildersOpts,
      }),
      sources: input.content.sources
        ? input.content.sources.map(i => creditMapper(i, buildersOpts))
        : [],
    }

    // disabled because of https://drewlagency.slack.com/archives/C06EHUX8D46/p1739500956837539
    // injectTrendingArticlesList(
    //   result.meta.engagementContainerId,
    //   ['sg_131955'], // fix for https://drewl.atlassian.net/browse/DT-7128
    //   result.sidebarContent
    // )

    const featuredImage = imageMapper(input.content.image, buildersOpts)

    // fix DR-1129
    if (featuredImage) {
      featuredImage.caption = null
    }
    // end fix DR-1129

    if ('table' in input) {
      return {
        ...result,
        ...productBarsMapper(result.blocks),
        badges: imageListMapper(input.content.badges, buildersOpts) ?? [],
        image: featuredImage,
        ...reviewProductPartMapper(input),
      }
    }
    const blocks =
      result.startsWithImage || !featuredImage
        ? result.blocks
        : [
            {
              resource: 'nc-img',
              image: featuredImage,
              badges: [],
            } as const,
            ...result.blocks,
          ]

    // noinspection PointlessBooleanExpressionJS // input type of result.startsWithImage may not be Boolean
    return {
      ...result,
      startsWithImage: result.startsWithImage === true ? true : featuredImage !== null,
      ...productBarsMapper(blocks),
    }
  }
  if (input.template === 'about-layout') {
    return aboutNewPageMapper(input, {
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
      ...buildersOpts,
    })
  }
  if (input.template === 'contacts-layout') {
    return contactsPageMapper(input, {
      pagePath: lb.buildSiteLink({ path: 'post', params: { slug } }).href,
      ...buildersOpts,
    })
  }

  logWarning('Unknown page template: ', input)
  return null
}

// **********************

const componentItemMap: MapComponentItem<ApiComponentPropsStrictSG, 'type', DSNCSG | DSNCSG[]> = {
  review_from_web: ncReviewFromWebMapper,
  'newsletter-title': newsTitleMapper,
  alert: ncAlert,
  featured_comment: ncEngagementStarter,
  error: ncError,
  'unsafe-html': ncUnsafeHtml,
  products_quiz: ncProductsQuiz,
  separator: ncSeparator,
  deals_list: i => ncDealsList(i, buildersOpts),
  newsletter: i => ncNewsletter(i, buildersOpts),
  deals_medium: i => ncDealsSlider(i, buildersOpts),
  why_should_you_trust: i => ncTrustUs(i, buildersOpts),
  deals_slider: i => ncDealsSlider(i, buildersOpts),
  deals_large: i => ncDealsLarge(i, buildersOpts),
  product: i => ncProduct(i, buildersOpts),
  poll: ncPoll,
  more_posts: i => ncMorePosts(i, buildersOpts),
  section: ncSection,
  image: i => ncImage(i, buildersOpts),
  quote: ncQuote,
  see_also: i => ncSeeAlso(i, buildersOpts),
  table: i => ncTable(i),
  embed: ncEmbed,
  image_comparison: i => ncImgComparison(i, buildersOpts),
  related_articles: i => ncRelatedArticles(i, buildersOpts),
  opinions: i => ncOpinions(i, buildersOpts),
  gallery: i => ncGallery(i, buildersOpts),
  envira_gallery: i => ncCarousel(i, buildersOpts),
  tldr: ncTldr,
  image_with_badge: i => ncImageWithBadge(i, buildersOpts),
  ad: i => ncAd(i, { componentItemMapper }),
  audio_chart: i => ncAudioChart(i),
  ez_col: i => ncColumns(i, { componentItemMapper }),
  pre: ncPre,
  script: ncScript,
  promoted: i => ncPromoted(i, { componentItemMapper }),
  video: ncVideo,
  audio: ncAudio,
  rich_content: i => ncMulti(i, { componentItemMapper }),
  media_query: i => ncMulti(i, { componentItemMapper }),
  post_list: i => ncPostsList(i, buildersOpts),
  feedback_form_data: i => ncFeedback(i, { componentItemMapper }),
  video_slider: ncVideoSlider,
  adp_faqs: i =>
    ncAdpFaqs(i, { componentItemMapper, postLinkBuilder: buildersOpts.postLinkBuilder }),
  faq: i => ncFaq(i, { componentItemMapper, postLinkBuilder: buildersOpts.postLinkBuilder }),
  twitter: ncTwitter,
  sponsored: i => ncSponsored(i, { componentItemMapper }),
  'faq-submission': ncFaqSubmission,
  related_posts: () => [
    { resource: 'nc-revcontent' },
    { title: 'You might like', resource: 'nc-recommend', itemsInList: 6 },
  ],
  disclosure_box: i => ncDisclosureBox(i, { componentItemMapper }),
  best_product_gallery: i => ncBestProductGallery(i, buildersOpts),
  best_product_title: i => ncBestProductTitle(i, buildersOpts),
  buttons: ncLinkedButtons,
  adp_table: ncSpecTable,
  app: i => ncApp(i, buildersOpts),
}

type IComponentItemMapper = (i: ApiComponentPropsSG) => DSNCSG | DSNCSG[]

export function componentItemMapper(input: ApiComponentPropsSG): DSNCSG | DSNCSG[] {
  if (typeof input === 'string') {
    return ncString(input)
  }

  const mapper = componentItemMap[input.type] as IComponentItemMapper
  if (mapper) {
    return mapper(input)
  }

  // fallback for unknown shared-code-components
  logWarning('Unknown nc component', input)
  return []
}

const contentBlockMap: MapComponentItem<
  ApiContentBlockSG,
  'type',
  DSContentBlockSG | DSContentBlockSG[]
> = {
  featured: i => cbFeatured(i, buildersOpts),
  component: i =>
    cbComponent(i, { componentItemMapper, postLinkBuilder: buildersOpts.postLinkBuilder }),
  missed: i => cbMissed(i, { codecGetMissedProps: si => codecGetMissedProps(si, buildersOpts) }),
  tiles_with_image: i => cbTiles(i, buildersOpts),
  tiles_without_image: i =>
    cbColoredTiles(i, { componentItemMapper, postLinkBuilder: buildersOpts.postLinkBuilder }),
  coupled_post_list: i => cbCoupledPosts(i, buildersOpts),
}

export function contentBlockMapper(
  input: ApiContentBlockSG
): DSContentBlockSG | DSContentBlockSG[] {
  const mapper = contentBlockMap[input.type]
  if (mapper) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    return mapper(input as any)
  }

  logWarning('Unknown content block', input)
  return [] // unknown content block
}
